export const SIDEBAR_ITEM_BUTTON_CLASS_NAME = 'sidebar-item-button';
export const SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME = 'sidebar-item-button-active';
